import { CartDisplayer, CommentSection, CustomBottomBar, DeliveryInfos, DropdownButton } from '@components';
import { Button, Container, Icon, Input, Modal, showToast, Typography } from '@design-system';
import React from 'react';
import { FaStar } from 'react-icons/fa';
import { IoMdMore } from 'react-icons/io';
import './CartPage.scss';
import { useCartPageVM } from './useCartPageVM';

export const CartPage: React.FC = () => {
    const {
        actions,
        cartName,
        comment,
        deliveryDate,
        getTotalItems,
        handleOperatorChange,
        handleSaveCart,
        isOrderable,
        items,
        operatorsOptions,
        removeItem,
        selectedOperatorId,
        selectedWorksiteId,
        setCartName,
        setShowModal,
        updateQuantity,
        worksitesOptions,
        showModal,
        setSelectedWorksiteId,
        setDeliveryDate,
        setComment,
        handleCreateOrder,
        isCreatingOrder
    } = useCartPageVM();

    return (
        <div className="cart-page">
            <Container className="cart-page-header" padding="medium large" radius="none">
                <div className="cart-page-infos">
                    <Typography intrinsic="h2">Mon panier</Typography>
                    <Typography intrinsic="p" variant="secondary" color="grey" className="mt-small-spacing">
                        {getTotalItems()} articles
                    </Typography>
                </div>
                <DropdownButton icon={<IoMdMore />} actions={items.length > 0 ? actions : []} color="grey" />
            </Container>

            <Container className="cart-page-content" padding="medium" radius="none">
                <CartDisplayer items={items} onRemoveItem={removeItem} onUpdateQuantity={updateQuantity} />

                <DeliveryInfos
                    operatorsOptions={operatorsOptions}
                    worksitesOptions={worksitesOptions}
                    selectedOperatorId={selectedOperatorId}
                    selectedWorksiteId={selectedWorksiteId}
                    deliveryDate={deliveryDate}
                    onOperatorChange={handleOperatorChange}
                    onWorksiteChange={setSelectedWorksiteId}
                    onDeliveryDateChange={setDeliveryDate}
                />

                <CommentSection comment={comment} onCommentChange={setComment} />
            </Container>

            <Modal
                open={showModal}
                setClose={() => setShowModal(false)}
                title="Enregistrer le panier dans les favoris"
                titleIcon={<Icon icon={<FaStar />} size={20} color="marine" />}
                footer={
                    <div className="modal-footer">
                        <Button
                            color="grey"
                            variant="tertiary"
                            onClick={() => {
                                setShowModal(false);
                            }}
                        >
                            <Typography intrinsic="h4">Annuler</Typography>
                        </Button>
                        <Button
                            color="green"
                            variant="secondary"
                            size="small"
                            onClick={() => {
                                if (!cartName) {
                                    showToast({
                                        message: 'Veuillez entrer un nom pour le panier',
                                        type: 'error'
                                    });
                                    return;
                                }
                                handleSaveCart();
                            }}
                        >
                            <Typography intrinsic="h4">Enregistrer</Typography>
                        </Button>
                    </div>
                }
            >
                <Input placeholder="Nom du panier" value={cartName} onValueChange={setCartName} className="cart-name-input" />
            </Modal>

            <CustomBottomBar>
                <Button
                    color="marine"
                    variant="primary"
                    size="fullwidth"
                    onClick={handleCreateOrder}
                    disabled={!isOrderable || isCreatingOrder}
                >
                    <Typography intrinsic="h4">{isCreatingOrder ? 'Envoi en cours…' : 'Envoyer ma demande'}</Typography>
                </Button>
            </CustomBottomBar>
        </div>
    );
};
